import { useApiGetQueryExecutions } from '@repo/api-codegen';
import { TableV2 } from '../../../../components/TableV2';
import { useActions } from './useActions.hooks';
import { useColumns } from './useColumns.hooks';

interface QueryHistoryProps {
	queryId: string;
	lookBackDays: number;
	fromDrawer?: boolean;
}

function QueryHistory({
	queryId,
	lookBackDays,
	fromDrawer = false,
}: QueryHistoryProps) {
	const actions = useActions();
	const columns = useColumns(fromDrawer);

	return (
		<TableV2
			withInteractiveHeader
			withActions={actions}
			pluralTypeString="executions"
			columns={columns}
			height={524}
			extraFooterSpace
			// @ts-ignore
			usePaginationList={useApiGetQueryExecutions}
			useCodegenListInterface={true}
			usePaginationListOptions={{
				pathParams: {
					queryId,
				},
			}}
			defaultRequiredSearchParams={{
				page: 1,
				page_size: 50,
				lookback_days: lookBackDays,
			}}
		/>
	);
}

export default QueryHistory;
